import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

export const BASE_TITLE = 'TQC';

@Injectable()
export class AppTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  public override updateTitle(routerState: RouterStateSnapshot): void {
    const suffix = this.buildTitle(routerState);
    this.title.setTitle(suffix ? `${BASE_TITLE} - ${suffix}` : BASE_TITLE);
  }
}
